import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ConfigContext, UserContext } from '../../context';
import { IconLabel, getCssVar } from '../../shared';
import { NoContent } from '../Error';

import classes from './FrontDoorTab.module.scss';

export const FrontDoorTab: FunctionComponent = () => {
  const { t } = useTranslation();

  const { tabIndex } = useParams();

  const { channelId } = useContext(UserContext).userInfo.userData;

  const { config } = useContext(ConfigContext);

  const { tabs: frontDoorTabs = [] } = { ...config.elements.frontDoor };

  const tab = useMemo(() => frontDoorTabs[Number(tabIndex) - 1], [frontDoorTabs, tabIndex]);

  if (!tab || !tab.items.length || tab.channelsExclude.includes(channelId)) {
    return <NoContent />;
  }

  const { titleLocaliseKey, items } = tab;

  return (
    <div className={classes['front-door-tab']}>
      {titleLocaliseKey && (
        <h1 className={classes['front-door-tab__title']}>{t(titleLocaliseKey)}</h1>
      )}
      <div className={classes['front-door-tab__list']}>
        {items.map(({ titleLocaliseKey, subTitleLocaliseKey, imageSrc, linkUrl }, index) => {
          const itemContent = (
            <>
              {imageSrc && (
                <div className={classes['front-door-tab__list-item-image-wrapper']}>
                  <img
                    className={classes['front-door-tab__list-item-image']}
                    src={imageSrc}
                    alt={''}
                  />
                </div>
              )}

              <div className={classes['front-door-tab__list-item-description']}>
                <div className={classes['front-door-tab__list-item-title-wrapper']}>
                  {titleLocaliseKey && (
                    <div className={classes['front-door-tab__list-item-title']}>
                      {t(titleLocaliseKey)}
                    </div>
                  )}
                  <IconLabel
                    iconId={'arrow-rounded-right'}
                    iconSize={20}
                    color={getCssVar('--front-door-tab-item-icon-color')}
                    className={classes['front-door-tab__list-item-icon']}
                    singleColor
                  />
                </div>
                {subTitleLocaliseKey && (
                  <div className={classes['front-door-tab__list-item-subTitle']}>
                    {t(subTitleLocaliseKey)}
                  </div>
                )}
              </div>
            </>
          );

          if (!linkUrl) {
            return (
              <div key={index} className={classes['front-door-tab__list-item']}>
                {itemContent}
              </div>
            );
          }

          return (
            <a
              key={index}
              className={classes['front-door-tab__list-item']}
              href={linkUrl}
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              {itemContent}
            </a>
          );
        })}
      </div>
    </div>
  );
};
